import * as _ from 'lodash';

import { Component, OnInit, Input } from '@angular/core';
import { ToastService } from '@wephone-utils';
import { PhoneCall } from '@wephone-app-phone/services';
import { TransferRequest, TransferDestinationType } from '@wephone-core/core/call_transfer';
import { EntityManager } from '@wephone-core/wephone-core.module';
import { PhoneService } from '@wephone-app-phone/services/phone/phone.service';
import { _ti } from '@wephone-translation';
import { UserRepository } from '@wephone-core/model/repository/user';
import { UserEntity } from '@wephone-core/model/entity/user';
import { CrmContactService } from '@wephone-core/service/crm-contact.service';

@Component({
  selector: 'app-crm-contact-history',
  templateUrl: './crm-contact-history.component.html',
  styleUrls: ['./crm-contact-history.component.scss']
})
export class CrmContactHistoryComponent implements OnInit {
  @Input() activeCall: PhoneCall;
  private readonly userRepo: UserRepository;
  owner: UserEntity;
  lastHistory: any;
  histories: any;
  transferReq = new TransferRequest(TransferDestinationType.USER);

  constructor(
    private readonly crmContactService: CrmContactService,
    private readonly phoneService: PhoneService,
    private readonly em: EntityManager,
    private readonly toastService: ToastService,
  ) {
    this.userRepo = this.em.getRepository('UserRepository');
  }

  ngOnInit(): void {
    void this.crmContactService.getOwner(this.activeCall.remoteNumberInLocalFormat()).then(o => this.owner = o);
    void this.crmContactService.getHistory(this.activeCall.remoteNumberInLocalFormat()).then(h => {
      this.histories = h;
      if (this.histories && this.histories.length) {
        this.lastHistory = _.head(this.histories);
      }
    });
  }

  transferCall(userId: number): void {
    const user = this.userRepo.getObjectById<UserEntity>(userId);
    if (!user) {
      this.toastService.showError(_ti('contact_history.message.agent_not_found'));
      return;
    }
    this.transferReq.destination = user;
    this.transferReq.assisted = true;
    this.phoneService.transferCall(this.activeCall, this.transferReq);
  }
}
